export default __webpack_public_path__ + "static/media/triangle-right.f95aa8a8.svg";